import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mb-banner',
  imports: [CommonModule],
  templateUrl: './mb-banner.component.html',
})
export class MbBannerComponent {
  @Input() isModal = false;
  @Input() title = '';
  @Input() type = '';
  @Input() icon = '';

  get bannerClass(): string {
    switch (this.type) {
      case 'info':
        return 'bg-mbaza-green';
      case 'warning':
        return 'bg-mbaza-red';
      default:
        return 'bg-mbaza-gray-light text-black';
    }
  }

}
